import { Box, Tooltip } from "@mui/material"
import dayjs from "dayjs"

export const DRV_ACK = { ACKED: "ACKED", PENDING: "PENDING" }

/**
 * Driver acknowledgement (รับทราบ) of a task step { DrvId, DrvAckTm, IsCmpt }, pressed in the mobile app.
 * ACKED: pressed. PENDING: not pressed and neither the step (IsCmpt) nor the job order (FinDte) is done.
 * null: nothing to show — no driver, a subcontractor (IsSub, doesn't use the app), or done without
 * an ack, which no longer needs chasing.
 */
export const drvAckState = (contSts, msData, finDte) => {
  if (!contSts?.DrvId || msData?.driverObj?.[contSts.DrvId]?.IsSub) return null
  if (contSts.DrvAckTm) return DRV_ACK.ACKED
  return contSts.IsCmpt || finDte ? null : DRV_ACK.PENDING
}

export const drvAckTitle = (drvAckTm) => drvAckTm ? `รับทราบ: ${dayjs(drvAckTm).format("DD/MM/YYYY HH:mm")}` : "ยังไม่รับงาน"

/** Red dot for a step the driver hasn't acknowledged yet. */
export const AckDot = ({ sx }) => (
  <Box component="span" sx={{
    width: 8, height: 8, borderRadius: "50%", flexShrink: 0,
    bgcolor: "error.main", boxShadow: "0 0 0 1.5px white", // ring keeps it visible on red rows
    ...sx
  }} />
)

/** Tooltip with the ack time (or ยังไม่รับงาน) on a driver button, when there is an ack state to show. */
export const DrvAckTooltip = ({ contSts, msData, finDte, children }) => drvAckState(contSts, msData, finDte)
  ? <Tooltip title={drvAckTitle(contSts.DrvAckTm)} arrow>{children}</Tooltip>
  : children

/** Red dot in the top-left corner inside a driver button while its step is PENDING. */
export const DrvAckCornerDot = ({ contSts, msData, finDte }) => drvAckState(contSts, msData, finDte) === DRV_ACK.PENDING
  ? <AckDot sx={{ position: "absolute", top: 1, left: 1 }} />
  : null
